import React from 'react';
import { CardLinkView } from '../../../view/LinkView';
import { loadingPlaceholderClassName } from './LazyFallback';
export var LoadingCardLink = function LoadingCardLink(_ref) {
  var isSelected = _ref.isSelected,
    url = _ref.url,
    placeholder = _ref.placeholder;
  return /*#__PURE__*/React.createElement(CardLinkView, {
    key: 'lazy-render-key',
    testId: 'lazy-render-placeholder',
    "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
    isSelected: isSelected,
    link: url
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: loadingPlaceholderClassName,
    placeholder: placeholder
  });
};